export default {
  sweet_alert: {
    default: {
      cancelButtonText: 'Cancelar',
      cannot_exec_command: 'No se pudo ejecutar el comando',
      confirmButtonText: 'Confirmar',
      confirmDeleted: 'Tu archivo ha sido borrado',
      confirmDeletedPaymentGateway: 'Tu pasarela de pago fue eliminada',
      confirmResetPassword: 'Tu contraseña fue regenerada',
      continueButtonText: 'Continuar',
      defaultError: 'Algo salió mal, por favor contacte con soporte.',
      defaultErrorTitle: 'Error',
      deleteButtonText: 'Eliminar',
      deleted: 'Borrado',
      email: 'email',
      error_dimension_text: 'la dimensión mínima de la imagen es de 200x200 y la máxima de 300x300',
      errorText: 'No puedes realizar esta acción',
      errorTitle: 'Error',
      mailSended: 'Correo enviado',
      mikrotik_not_linked: 'Mikrotik no vinculado',
      not_found: 'Algo ha ido mal, por favor contacte con el equipo de soporte',
      ping: 'Ping',
      searchDeleted: 'Tu registro ha sido borrado',
      are_you_sure_title: '¿Está seguro?',
      text: 'No vas a poder recuperar esta información',
      text_deleteRecord: 'Perderás tus búsquedas',
      text_delete_all_records: 'Perderás todos tus búsquedas guardadas',
      title: '¿Seguro quieres borrar?',
      title_delete_payment_gateway: '¿Seguro quieres eliminar la pasarela de pago del cliente?',
      title_delete_warehouse: '¿Seguro quieres eliminar el almacén?',
      title_deleteRecord: '¿Seguro quieres borrar tu registro de búsqueda?',
      title_password_reset: '¿Seguro quieres regenerar la contraseña?',
      title_publish: '¿Seguro quieres publicar la novedad?',
      title_update_success: 'Actualizado correctamente',
      titleSendMail: 'Enviar correo de prueba',
      unauthorize: 'Desautorizar',
      unpenalize_mikrotik: 'Despenalizar Mikrotik',
      service_error: 'Servicio no disponible. Intente mas tarde'
    },
    clients: {
      massive_destroy: {
        title: 'Borrar masivamente',
        text: 'Los clientes seleccionados serán borrados <strong>al igual que sus contratos</strong>. Podrá buscarlos aplicando el filtro "Borrados"'
      }
    },
    cloud_license: {
      acs_license: {
        cannot_subscribe: 'No puede suscribirse con total menor o igual a $0',
        cannot_update_price: 'No puedes actualizar con precio menor o igual a $0',
        default_error: 'No se pudo realizar la suscripción',
        delete_error: 'No se pudo cancelar la suscripción',
        delete_loading_text: 'Cancelando la suscripción a ACS…',
        delete_successful: 'Se cancelo la suscripción con exito',
        subscribe_loading_text: 'Procesando suscripción a ACS…',
        text_confirm_subscribe_total: 'Se realizará la suscripción por ${{total}}',
        text_confirm_subscribe_total_installation_price:
          'Se realizará la suscripción por ${{total}} y se va a generar una factura de instalación por ${{installation_price}}',
        text_confirm_update_subscribe: 'Se actualizará la suscripción',
        text_confirm_update_subscribe_total: 'Se actualizará la suscripción por ${{total}}',
        text_success_subscribe: 'Se realizó la suscripción con exito',
        title_confirm_subscribe: '¿Quieres suscribirte a ACS?',
        title_delete_subscribe: '¿Quieres cancelar tu suscripción ACS?',
        title_update_subscribe: '¿Quieres actualizar la suscripción?',
        update_error: 'No se pudo actualizar la suscripción',
        update_loading_text: 'Actualizando suscripción a ACS…',
        update_successful: 'Se actualizo la suscripción con exito'
      },
      title_enable_internal_use: 'Habilitar ISP para uso interno',
      title_disable_internal_use: 'Deshabilitar ISP para uso interno',
      text_enable_internal_use: '¿Desea Habilitar el ISP para uso interno?',
      text_disable_internal_use: '¿Desea Deshabilitar el ISP para uso interno?',
      text_loading_internal_use: 'Realizando el cambio',
      text_success_internal_use: 'Se realizó el cambio con exito',
      text_error_internal_use: 'No se ha podido realizar el cambio',

      cancel_discount_trial_license:
        'Al cancelar tu suscripción tus descuentos y periodo de prueba finalizarán. La suscripción se cancelará al final del período actual.',
      cancel_license: '¿Quieres cancelar tu suscripción?',
      cloud: {
        default_error: 'No se pudo realizar la instalación',
        install_loading_text: 'Procesando la facturación...',
        text_confirm_subscribe_total_installation_price:
          'Se va a generar una factura de instalación por ${{installation_price}}',
        text_success_subscribe: 'Se realizó la factura con exito',
        title_confirm_install: '¿Quieres instalar Cloud?'
      },
      hola_suite: {
        cancel_send_text: 'Su notificación no se enviará, está seguro?',
        cancel_send_title: 'Cancelar envío',
        cannot_subscribe: 'No puede suscribirse con total $0,00',
        default_error: 'No se pudo realizar la suscripción',
        delete_error: 'No se pudo cancelar la suscripción',
        delete_loading_text: 'Cancelando la suscripción a Hola Suite…',
        delete_successful: 'Se cancelo la suscripción con exito',
        subscribe_loading_text: 'Procesando suscripción a Hola Suite...',
        text_confirm_subscribe_total: 'Se realizará la suscripción por ${{total}}',
        text_confirm_subscribe_total_installation_price:
          'Se realizará la suscripción por ${{total}} y se va a generar una factura de instalación por ${{installation_price}}',
        text_confirm_update_subscribe: 'Se actualizará la suscripción',
        text_confirm_update_subscribe_total: 'Se actualizará la suscripción por ${{total}}',
        text_success_subscribe: 'Se realizó la suscripción con exito',
        title_confirm_subscribe: '¿Quieres suscribirte a Hola Suite?',
        title_delete_subscribe: '¿Quieres cancelar tu suscripción Hola Suite?',
        title_update_subscribe: '¿Quieres actualizar la suscripción?',
        update_error: 'No se pudo actualizar la suscripción',
        update_loading_text: 'Actualizando suscripción a Hola Suite...',
        update_successful: 'Se actualizo la suscripción con exito'
      },
      invoice: {
        finalize_loading_text: 'Intentando emitir la factura...',
        payment_loading_text: 'Intentando realizar el pago...',
        text_cannot_finalize: 'No se pudo emitir la factura',
        text_cannot_payment: 'No se pudo realizar el pago',
        text_finalize_invoice: 'Se va a emitir la factura {{number_invoice}} y se intentará cobrar al cliente',
        text_pay_with_default_payment_method:
          'Se va a realizar el pago con el método de pago por defecto ({{brand}} terminada en {{last_four_numbers}})',
        text_success_finalize: 'La factura se emitio con éxito',
        text_success_payment: 'El pago se realizó con éxito',
        title_confirm_finalize: '¿Quieres emitir esta factura?',
        title_confirm_payment: '¿Quieres realizar un pago?'
      },
      reactivate_suscription_successful: 'Se re suscribio la suscripción con éxito',
      something_wrong: 'Algo salió mal',
      text_confirm_reactivate_suscription: 'Vamos a re suscribir la suscripción con 2 días de prueba',
      title_reactivate_suscription: '¿Quieres  re suscribir la suscripción?',
      unlock_plan: '¿Quieres desbloquear el Plan?',
      update_loading_text: 'Estamos re suscribiendo la licencia'
    },
    contracts: {
      confirmUpdate: 'Confirmar',
      massive_update_title: 'Actualización masiva',
      massive_unlink_title: 'Desvincular ONUs masivamente',
      confirmDeleted: 'El contrato ha sido eliminado',
      title_with_ont: 'Eliminar contrato y desautorizar ONT',
      text_with_ont:
        'Este contrato tiene un  a ONT asociada. Al eliminarlo, la ONT será desautorizada. ¿Desea continuar?',
      need_ip_and_server: 'Necesita una IP válida y Servidor para obtener la dirección MAC',
      need_ip_and_server_and_interface: 'Necesita una IP válida, Servidor e Interfaz para obtener la dirección MAC',
      authorize_ont: {
        authorize: 'Autorizar ONU',
        title: '¿Quiere autorizar la ONU?',
        text: 'El contrato, {{contract}}, está asociado a la OLT {{olt}} pero no tiene una ONU asociada.'
      }
    },
    isps: {
      regen_token: {
        regenToken: 'Token regenerado',
        text: 'No podrá recuperar el token anterior',
        title: '¿Está seguro?',
        errorText: 'No puedes subir imagenes mayores a 10mb'
      },
      update: {
        text: 'Se va a refrescar la pagina para mostrar los nuevos datos'
      },
      archive: {
        title: '¿Archivar ISP?',
        text: 'Al archivar el ISP "{{name}}" modificará el nombre del ISP y los correos de todos los empleados.',
        confirm: 'Sí, archivar'
      },
      archive_error: {
        title: 'Error al archivar el ISP',
        text: 'Intente nuevamente o contacte a soporte.',
        text_with_error: '{{error}}'
      }
    },
    naps: {
      destroy_close_button_text: 'Cerrar',
      destroy_loading_text: 'Eliminando NAP',
      destroy_error_title: 'Error eliminando NAP'
    },
    nas: {
      confirmDeleted: 'La Nas ha sido eliminada'
    },
    notifications: {
      title: '¿Está seguro?',
      text: 'No podrá recuperarlo',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar'
    },
    notification_smses: {
      title: 'Escriba el número de teléfono de destino',
      placeholder: 'Número con código de país',
      buttonSend: 'Enviar'
    },
    payment_gateways: {
      text_to_propagate:
        'En caso de propagar el estado del informe de facturas afectará a todos los clientes asociados a esta pasarela.'
    },
    plans: {
      confirmDeleted: 'Su plan ha sido eliminado'
    },
    portal_configurations: {
      'file-too-large': 'No puedes subir imagenes mayores a 10mb',
      'file-invalid-type': 'Formato invalido, permitidos: .png, jpg, jpeg'
    },
    ppp_profiles: {
      confirmDeleted: 'Tu Perfil PPP ha sido borrado',
      deleted: 'Borrado'
    },
    olt: {
      apply_changes: 'Aplicar Cambios',
      authorize_ont_successfully: 'Se autorizó la ONU exitosamente',
      disable_catv_ont_succesfully: 'Se deshabilitó CATV exitosamente',
      enable_catv_ont_succesfully: 'Se habilitó CATV exitosamente',
      disable_wan_access_succesfully: 'Se deshabilitó el acceso WAN exitosamente',
      enable_wan_access_succesfully: 'Se habilitó el acceso WAN exitosamente',
      factory_reset_succesfully: 'Se realizó exitosamente el restablecimiento de fábrica de la ONU',
      link_ont_successfully: 'Se vinculó la ONU exitosamente',
      link: 'Vincular',
      olt_online: 'OLT conectada',
      olt_offline: 'OLT desconectada',
      ont_authorized_succesfully: 'ONU autorizada exitosamente',
      ont_authorized_text: 'Detalles importantes de la autorización:',
      ont_linked_succesfully: 'ONU vinculada exitosamente',
      ont_linked_text: 'Detalles importantes de la vinculación:',
      reboot_ont_succesfully: 'Se reinició la ONU exitosamente',
      reboot: 'Reiniciar ONU',
      reconfig_ont_succesfully: 'Se reescribió la configuración de la ONU exitosamente',
      reconfigure_ont_successfully: 'Se reescribió la configuración de la ONU exitosamente',
      reconfig_wan_succesfully: 'Se reescribió la configuración WAN exitosamente',
      resync_ont_successfully: 'Se resincronizó la ONU exitosamente',
      reconfigure_wan: 'Reescribir configuración WAN',
      reconfigure: 'Reescribir configuración ONU',
      unauth_ont_succesfully: 'Se desautorizó la ONU exitosamente',
      unauth_ont_successfully: 'Se desautorizó la ONU exitosamente',
      unauth: 'Desautorizar',
      unlink_ont_succesfully: 'Se desvinculó la ONU del contrato exitosamente',
      unlink: 'Desvincular',
      resync: 'Resincronización',
      connected: 'Conectado',
      not_connected: 'No conectado',
      not_configured: 'No configurado',
      olt_connection_status: 'Estado de conexión de la OLT',
      connection_type: 'Tipo de Conexión',
      autodiscover_onts: 'Autodescubrimiento ONUs'
    },
    olt_server_interfaces: {
      autodiscover_refresh: 'Refrescar Autodiscover'
    },
    // ---> Las traducciones de sweet alerts de ONU/OLT van todas arriba, en la key: olt
    ont: {
      authorize_ont_successfully: 'Se autorizó la ONU exitosamente',
      authorize: 'Autorizar',
      link_ont_successfully: 'Se vinculó la ONU exitosamente',
      link: 'Vincular',
      reconfigure_ont_successfully: 'Se reescribió la configuración de la ONU exitosamente',
      reconfigure: 'Reescribir configuración',
      unauth: 'Desautorizar',
      unauth_ont_successfully: 'Se desautorizó la ONU exitosamente',
      unauthorizing: 'Desautorizando la ONU, por favor aguarde.'
    },
    push_notification: {
      add_all_clients_text: 'Todos los Clientes serán agregados',
      add_all_clients_title: 'Agregar Clientes',
      all_clients_removed: 'Se removieron todos los Clientes de esta notificación',
      cant_add_clients: 'No puedes agregar clientes a esta notificación después de 15 minutos, ya fue enviada',
      cant_delete: 'No puedes eliminar esta notificación después de 15 minutos, ya fue enviada',
      cant_edit: 'No puedes editar esta notificación después de 15 minutos, ya fue enviada',
      clients_added_text: 'Se agregaron {{count}} {{client}} a esta notificación.',
      clients_added_title: 'Clientes Agregados',
      clients_already_exits_text: 'No hay Clientes para agregar a esta notificación.',
      clients_not_found: 'No hay Clientes con este criterio de búsqueda',
      clients_removed: 'Se removieron los Clientes asociados a esta notificación exitosamente',
      need_clients: 'Necesitas seleccionar al menos un cliente',
      no_clients_found: 'No se pudo encontrar ningún cliente',
      no_clients_text: 'No hay Clientes Asociados en esta notificación para Remover',
      notification_deleted: 'Se ha eliminado la notificación',
      remove_all_clients_text: 'Se removerán todos los Clientes asociados a esta Notificación',
      remove_all_clients_title: 'Precaución',
      remove_filtered_clients_text: 'Se eliminara {{count}} {{client}} de la Notificación',
      remove_filtered_clients_title: 'Eliminar',
      time_expired_text: 'Ya no puedes realizar esta accion pasado 15 minutos',
      time_expired_title: 'Tiempo Expirado'
    },
    sale_desk: {
      source: {
        destroy_close_button_text: 'Cerrar',
        destroy_loading_text: 'Eliminando origen',
        destroy_error_title: 'Error eliminando origen'
      },
      leads: {
        text: 'Se eliminarán los <b>prospectos</b> y los <b>tickets de mesa de venta</b> asociados.'
      },
      prospects: {
        text: 'Se eliminarán los <b>tickets de mesa de venta</b> asociados.'
      },
      tags: {
        destroy_close_button_text: 'Cerrar',
        destroy_loading_text: 'Eliminando Tag',
        destroy_error_title: 'Error eliminando Tag'
      }
    },
    server_configurations: {
      cant_connect_to_mikrotik: 'No es posible conectarse al mikrotik',
      mikrotik_not_linked: 'Mikrotik no vinculado',
      need_clients: 'Necesitas seleccionar al menos un cliente',
      no_clients_found: 'No se pudo encontrar ningún cliente',
      no_clients_text: 'No hay Clientes Asociados en esta notificación para Remover',
      notification_deleted: 'Se ha eliminado la notificación',
      ping: 'Ping',
      remove_all_clients_text: 'Se removerán todos los Clientes asociados a esta Notificación',
      remove_all_clients_title: 'Precaución',
      remove_filtered_clients_text: 'Se eliminara {{count}} {{client}} de la Notificación',
      remove_filtered_clients_title: 'Eliminar',
      resync: 'Resincronización',
      time_expired_text: 'Ya no puedes realizar esta accion pasado 15 minutos',
      time_expired_title: 'Tiempo Expirado'
    },
    invoicing: {
      contract_discounts: {
        cancel_discount: {
          title: '¿Está seguro?',
          text: 'No podrá recuperarlo',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Cancelar descuento'
        },
        delete_discount: {
          title: '¿Está seguro?',
          text: 'No podrá recuperarlo',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Eliminar descuento'
        }
      },
      discount: {
        enable: {
          title: '¿Habilitar Descuento?',
          text: 'Al habilitar el descuento "{{name}}", será visible y asignable en los contratos',
          confirm: 'Sí, habilitar'
        },
        disable: {
          title: '¿Deshabilitar Descuento?',
          text: 'El descuento "{{name}}" afecta actualmente a {{contractsToApply}} contratos',
          confirm: 'Sí, deshabilitar'
        }
      },
      drafts: {
        remove_drafts: {
          title: '¿Está seguro que quieres borrar TODOS los borradores del filtro activo?'
        }
      },
      payment_receipt: {
        change_state_to_discarded: {
          title: '¿Está seguro?',
          text: 'El estado del comprobante pasará a descartado'
        },
        change_state_to_pending: {
          title: '¿Está seguro?',
          text: 'El estado del comprobante voverá a pendiente'
        },
        change_state_to_processed: {
          title: '¿Está seguro?',
          text: 'El estado del comprobante pasará a procesado'
        },
        change_state_error: {
          title: 'Ocurrió un error al actualizar el comprobante',
          text: 'Intente nuevamente más tarde'
        }
      },
      payment_transactions: {
        unbind: {
          title: '¿Está seguro?',
          text: 'La transacción de pago será desvinculada de esta factura'
        }
      }
    },
    invoicing_configuration: {
      destroy_close_button_text: 'Cerrar',
      destroy_error_title: 'Error eliminando configuración',
      destroy_loading_text: 'Eliminando configuración',
      'file-too-large': 'No puedes subir imagenes mayores a 10mb',
      'file-invalid-type': 'Formato invalido, permitidos: .png, jpg, jpeg'
    },
    tv_services: {
      directv_go: {
        cancel_subscription: {
          title: '¿Seguro quieres cancelar la suscripción?',
          subtitle: 'El cliente podrá disfrutar de los servicios que posee hasta fin de mes.',
          title_card_input: '¿Seguro quieres cancelar el Plan?',
          subtitle_card_input:
            'Cancelar el plan Básico implica la inactivación de la suscripción. El cliente podrá disfrutar de los servicios que posee hasta fin de mes cuando se haga efectiva la inactivación.'
        },

        cancel_subscription_success: {
          title: 'La suscripción se canceló correctamente'
        },

        cancel_subscription_error: {
          title: 'Error',
          subtitle: 'Ocurrió un error al cancelar la suscription. Intente de nuevo más tarde o contacte a soporte'
        },

        reset_password_success: {
          title: 'Contraseña regenerada con exito',
          subtitle: 'Se enviará un correo a {{mail}} con la nueva contraseña'
        },

        reset_password_error: {
          title: 'Error',
          subtitle: 'Ocurrió un error al regenerar la contraseña. Intente de nuevo más tarde o contacte a soporte'
        },

        reset_password: { title: '¿Seguro quieres regenerar la contraseña?' }
      }
    }
  }
};
